import styled, { css } from "styled-components"
import CloseIcon from "components/atoms/CloseIcon"
import Image from "components/atoms/Image"

const StyledContact = styled.div`
  height: 100%;
  display: flex;

  ${({ asPage }) =>
    !asPage &&
    css`
      transform: translateY(-50%);
      top: 50%;
      position: relative;
    `}

  ${({ theme }) => theme.mq.medium} {
    max-height: 80rem;

    ${({ asPage }) =>
      asPage &&
      css`
        padding: 7rem 0 0;
        min-height: 80rem;
      `};
  }
`

const StyledContactWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: ${({ theme }) => theme.gridWidth};
  padding: 0 ${({ theme }) => theme.layout.mobilePadding};
  margin: 0 auto;
  position: relative;
  flex-wrap: wrap;

  ${({ theme }) => theme.mq.medium} {
    flex-wrap: nowrap;
  }
`

const StyledTextWrapper = styled.div`
  padding-top: 8rem;
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  margin-bottom: 3.2rem;
  flex-wrap: wrap;

  ${({ theme }) => theme.mq.medium} {
    padding-top: 0;
    margin-bottom: 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
`

const StyledImageWrapper = styled.div`
  width: 100%;
  position: relative;
  ${({ theme }) => theme.mq.medium} {
    position: static;
    height: 40.4rem;
  }
`

const StyledFormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const titleStyles = css`
  box-shadow: inset 0 -0.3em white,
    inset 0 -0.5em ${({ theme }) => theme.color.senary03};
  width: fit-content;
  height: max-content;
  margin-bottom: 2.4rem;

  ${({ theme }) => theme.mq.medium} {
    margin-bottom: 0;
  }
`

const StyledImg = styled(Image)`
  width: 100%;
  height: 100%;
  max-height: 20.8rem;
  object-fit: cover;

  ${({ theme }) => theme.mq.medium} {
    position: absolute !important;
    right: 0;
    bottom: 0;
    max-height: 40rem;
    width: 50vw;
    max-width: 70rem;
  }
`

const StyledBackground = styled.div`
  background-color: ${({ theme }) => theme.color.main03};
  width: 100vw;
  height: 8.8rem;
  position: absolute;
  left: -1.6rem;
  z-index: -1;
  top: 30%;

  ${({ theme }) => theme.mq.medium} {
    top: initial;
    width: 8.8rem;
    height: 3.2rem;
    bottom: 40rem;
    left: 0;
  }
`
const StyledSuccessWrapper = styled.div`
  > h2,
  p {
    margin-bottom: 1.6rem;
  }

  padding-top: 8rem;

  ${({ theme }) => theme.mq.medium} {
    padding-top: 11.6rem;
  }
`

const StyledCloseButton = styled.div`
  position: absolute;
  top: 2.8rem;
  left: 2.2rem;
  border: none;
  background: none;
  width: 1.6rem;
  height: 1.6rem;
  cursor: pointer;
  z-index: 102;

  ${({ theme }) => theme.mq.medium} {
    top: 6rem;
  }
`

const StyledCloseIcon = styled(CloseIcon)`
  width: 100%;
  height: 2px;
  right: 0;
  left: initial;
`

const StyledSeparator = styled.div`
  display: none;
  width: 0.1rem;
  height: 100%;
  background: ${({ theme }) => theme.color.secondary04};

  ${({ theme }) => theme.mq.medium} {
    display: block;
  }
`

export {
  StyledContact,
  StyledContactWrapper,
  StyledFormWrapper,
  StyledTextWrapper,
  titleStyles,
  StyledImg,
  StyledBackground,
  StyledSuccessWrapper,
  StyledCloseButton,
  StyledCloseIcon,
  StyledSeparator,
  StyledImageWrapper,
}
